import { DashboardView } from '../sections/dashboard';

// ----------------------------------------------------------------------

export default function Dashboard() {
  return <DashboardView />;
}
